import { r } from 'config/routes'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { createPanelRoute } from 'views/panel/PanelLayout'

const ReportTemplateList = lazy(() => import('../List'))
const ReportTemplateEdit = lazy(() => import('../Edit'))
const ReportTemplateSingle = lazy(() => import('../Single'))

export const reportTemplatesRoutes: RouteObject[] = [
  createPanelRoute({
    path: r['reportTemplate.list'],
    element: <ReportTemplateList />,
  }),
  createPanelRoute({
    path: r['reportTemplate.add'],
    element: <ReportTemplateEdit />,
  }),
  createPanelRoute({
    path: r['reportTemplate.view'](),
    element: <ReportTemplateSingle />,
  }),
  createPanelRoute({
    path: r['reportTemplate.edit'](),
    element: <ReportTemplateEdit />,
  }),
]
